import { Download } from 'lucide-react';
import DropboxSaveButton from './DropboxSaveButton.jsx';

/**
 * Universal document action row: [⬇️ download] [☁️ open/save in Dropbox] [📋 copy share link].
 * DropboxSaveButton (icon-only) renders the cloud (open/save) and the copy-link icon itself
 * (P7/P8), so this component just prepends the download button. Used by the invoice list,
 * contracts list, and contract card so the row stays identical everywhere.
 */
export default function DocumentActions ({
  onDownload,
  downloadTitle = 'Скачать',
  showDownload = true,
  downloadDisabled = false,
  entity,            // 'contract' | 'invoice'
  entityId,
  dropboxUrl = null,
  sharedUrl = null,
  contractId,        // only for entity='invoice'
  dropboxDisabled = false,
  dropboxDisabledReason,
}) {
  return (
    <>
      {showDownload && (
        <button
          type="button"
          className="board-action-btn"
          onClick={onDownload}
          disabled={downloadDisabled}
          title={downloadTitle}
          aria-label={downloadTitle}
          style={{ padding: '4px 8px' }}
        >
          <Download size={14} />
        </button>
      )}
      <DropboxSaveButton
        entity={entity}
        entityId={entityId}
        dropboxUrl={dropboxUrl}
        sharedUrl={sharedUrl}
        contractId={contractId}
        disabled={dropboxDisabled}
        disabledReason={dropboxDisabledReason}
      />
    </>
  );
}
